export function formatPercentage(value?: number | null): string {
  if (value === null || value === undefined || isNaN(value)) {
    return '';
  }

  const percentage = value * 100;

  return `${Number(percentage.toFixed(2)).toString()}%`;
}
